import { SwitcherItem } from '@metrika/ui-kit/carbon';
import { styled } from '@metrika/ui-kit/emotion';

export const HeaderAvatar = styled.img`
   width: 30px;
   height: 30px;

   border-radius: 50%;
`;

export const TopLogo = styled.img`
   width: 2rem;
   height: 2rem;
   margin-left: ${({ theme }) => theme.layout.spacing03};
`;

export const SwitcherItemDisabled = styled(SwitcherItem)<{ href: string }>`
   .cds--switcher__item-link:focus {
      outline: none;
   }

   .cds--switcher__item-link,
   .cds--switcher__item-link:hover:not(.cds--switcher__item-link--selected) {
      padding: 6px 1rem;
      font-size: 0.875rem;
      font-weight: 600;
      line-height: 1.29;
      letter-spacing: 0.16px;
      display: block;
      color: ${({ theme }) => theme.colors.textHelper};
      border-bottom: 1px solid rgb(49, 49, 49);
      background: none;
   }
`;
